import styled from "@emotion/styled";
import { fonts, breakpoints, Typography } from "@trustpilot/businessapp-patternlibrary";

export const StyledCount = styled.span({
  background: "var(--action-critical-background)",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 700,
  letterSpacing: "-0.13px",
  width: 16,
  height: 16,
  border: `2px solid #fff !important`,
  borderRadius: "var(--border-radius-full)",
  color: "var(--neutral-white)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "absolute",
  cursor: "pointer",
  right: "15px",
  top: "7px",
  userSelect: "none",
  boxSizing: "content-box",
  zIndex: "100000 !important",
  [`@media (max-width: ${breakpoints.small}px)`]: {
    right: "-2px",
    top: "1px",
  },
});

export const StyledSection = styled.section({
  width: "260px",
});

export const Header = styled.div({
  display: "flex",
  alignItems: "center",
  margin: 0,
  padding: "16px",
  borderBottom: "1px solid #E5E5DD",
});

export const HeaderTypography = styled(Typography)({
  fontSize: "16px !important",
  fontStyle: "normal !important",
  lineHeight: "120% !important",
  fontWeight: "700 !important",
  letteSpacing: "-0.17px !important",
});

export const StyledIcon = styled.div({
  paddingRight: "16px",
  marginTop: "8px",
  ["> svg"]: {
    width: "20px",
    height: "20px",
  },
});

export const IconContainer = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

interface StyledNavItemProps {
  active: boolean;
}

export const StyledNavItem = styled.li<StyledNavItemProps>(
  {
    ...fonts["body-1"],
    fontWeight: fonts.weights.bold,
    display: "flex",
    position: "relative",
    alignItems: "center",
    margin: "0 24px 0 0",
    padding: "16px 0",
    cursor: "pointer",
    "&:last-child": {
      margin: 0,
    },
  },
  ({ active }) =>
    active
      ? {
          color: "var(--text-action)",
          "&::after": {
            content: '""',
            display: "block",
            height: "4px",
            width: "100%",
            position: "absolute",
            bottom: 0,
            left: 0,
            backgroundColor: "var(--action-secondary-hover-background)",
          },
        }
      : {
          color: "var(--text-subtle)",
        },
);

export const StyledNavItemCount = styled.span({
  borderRadius: "50%",
  margin: "0 0 0 4px",
  width: 16,
  height: 16,
  fontSize: 10,
  fontWeight: fonts.weights.bold,
  flexShrink: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "var(--neutral-white)",
  backgroundColor: "var(--neutral-gray-20)",
});

export const StyledList = styled.ul({
  maxHeight: "calc(80vh - 57px)",
  overflow: "auto",
  padding: "0 0 20px",
  margin: 0,
  listStyle: "none",

  [`@media (min-width: ${breakpoints.medium}px)`]: {
    maxHeight: 470,
  },
});

interface StyledItemProps {
  read: boolean;
}

export const StyledItem = styled.li<StyledItemProps>(
  {
    cursor: "pointer",
    borderBottom: "1px solid #E5E5DD",
    padding: 16,
    display: "block",
    color: "var(--alert-text)",
    background: "var(--elevation-surface)",
  },
  ({ read }) =>
    // The children have their own specific text and background colours based on hover and read
    // This nested approach targets StyledItemHeader, StyledItemTitle, StyledItemTimeago & StyledItemDescription
    !read && {
      background: "var(--elevation-surface-alt)",
      "&:hover": {
        background: "var(--action-secondary-hover-background)",
      },
    },
);

export const StyledItemHeader = styled.div({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: 4,
});

export const StyledItemHeaderTypography = styled(Typography)({
  fontSize: "14px !important",
  fontStyle: "normal !important",
  fontWeight: "700 !important",
  lineHeight: "120% !important",
  letterSpacing: "-0.15px !important",
});

export const StyledItemTitle = styled.div({
  ...fonts["body-2"],
  fontWeight: fonts.weights.bold,
  color: "var(--text-default)",
});

export const StyledItemDescription = styled.div({
  ...fonts["body-2"],
  color: "var(--alert-text)",
  paddingBottom: "2px",

  ".trustpilot-icon": {
    width: 8,
    height: 8,
    margin: "0 0 0 4px",
    color: "inherit",
    fill: "currentColor",
  },
});

export const StyledItemDescriptionUrlWrapper = styled.a({
  "&:hover": {
    textDecoration: "underline",
  },
});

export const StyledItemCta = styled.div({
  margin: "8px 0 0 0",
});

export const StyledItemTimeago = styled.div({
  fontSize: "12px",
  fontWeight: 100,
  color: "var(--text-default)",
  lineHeight: "20px",
  margin: 0,
  flexShrink: 0,
});

export const Empty = styled.div({
  ...fonts["body-1"],
  padding: "12px 16px",
  color: "var(--text-default)",
  borderBottom: `1px solid ${"var( --divider-subtle)"}`,
});
